import { CommonModule } from '@angular/common';
import { Component, inject, PLATFORM_ID, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { SalesAgentMangerComponent } from "../sales-agent-manger/sales-agent-manger";
import { TermsForms } from '../terms-forms/terms-forms';
import { ListingForms } from '../listing-forms/listing-forms';
import { PropertyStatsComponent } from '../property-stats/property-stats.component';
import { UserStatsComponent } from '../user-stats/user-stats.component';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';
import { MatTabsModule } from '@angular/material/tabs';
import { UserListComponent } from "../user-list/user-list.component";
import { TemplateSendComponent } from "../template-send/template-send";
import { EmailLogsComponent } from '../email-logs/email-logs';
import { W9Forms } from '../w9-forms/w9-forms';
import { ReferralUrls } from "../referral-urls/referral-urls";
import { PropertyList } from '../property-list/property-list';
import { AgentStateMapComponent } from '../agent-state-map/agent-state-map.component';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    SalesAgentMangerComponent,
    TermsForms,
    ListingForms,
    PropertyStatsComponent,
    UserStatsComponent,
    MatTabsModule,
    UserListComponent,
    TemplateSendComponent,
    W9Forms,
    EmailLogsComponent,
    ReferralUrls,
    PropertyList,
    AgentStateMapComponent
],
  templateUrl: './admin.html',
  styleUrl: './admin.scss',
})
export class AdminComponent implements OnInit {
  private seo = inject(SeoService);
  platformId = inject(PLATFORM_ID);

  ngOnInit() {
    this.seo.updateMetaTags('Admin', 'Admin panel for Horizinns', undefined, `${environment.appUrl}/admin`);
  }
}